import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { getDogProfileCompletion } from '@/utils/dogUtils';
import ReactApexChart from 'react-apexcharts';
import Modal from '@/components/Modal';
import useInfinitePosts from '@/hooks/useInfinitePosts';
import PostCard from '@/components/PostCard';

import {
  collection,
  getDocs,
  query,
  where,
  Timestamp,
} from 'firebase/firestore';
import { db } from '@root/firebase';

import Layout from '@components/Layout';
import Tour from '@components/Tour';
import { dashboardTourSteps } from '@utils/TourSteps/Dashboard';
import { dashboardMenu } from '@utils/Index';
import UserDashboard from './UserDashboard';
import ParticipantDashboard from './ParticipantDashboard';

function Dashboard() {
  const { globalData, globalUser, logout, defaultAvatarUrl } = useAuth();
  const navigate = useNavigate();

  return (
    <>
      <Layout>
        {/* breadcrumbs */}
        <div className='row page-titles'>
          <div className='col-lg-3'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item active'>My Account</li>
              <li className='breadcrumb-item'>Dashboard</li>
            </ol>
          </div>
          <div className='col-lg-4'>
            <Tour steps={dashboardTourSteps} pageKey='dashboard' />
          </div>
        </div>
        {/* End breadcrumbs */}

        {/* User Home Page */}
        {globalData.accountType == 'User' && <UserDashboard />}

        {/* Participant Home Page */}
        {globalData.accountType == 'Participant' && <ParticipantDashboard />}
      </Layout>
    </>
  );
}

export default Dashboard;
